/* unplugin-vue-components disabled */import script from "./guess.vue?vue&type=script&setup=true&lang=js"
export * from "./guess.vue?vue&type=script&setup=true&lang=js"

import "./guess.vue?vue&type=style&index=0&id=9eeeb022&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eeeb022"]])

export default __exports__